import { useTranslations } from 'next-intl';

import {
  SuccessContainer,
  SuccessText,
  SuccessHeading,
} from './NewsletterRegistration.styles';
import { NewsletterSuccessIcon } from './NewsletterSuccessIcon';

type NewsletterSignupSuccessProps = {
  showTitle?: boolean;
};

const NewsletterSignupSuccess = ({
  showTitle,
}: NewsletterSignupSuccessProps) => {
  const t = useTranslations(
    'features.newsletterRegistrationLegacy.newsletterRegistration',
  );

  return (
    <SuccessContainer>
      <NewsletterSuccessIcon />
      {showTitle && <SuccessHeading>{t('success.title')}</SuccessHeading>}
      <SuccessText>{t('success.text')}</SuccessText>
      <p>{t('success.subtext')}</p>
    </SuccessContainer>
  );
};

export { NewsletterSignupSuccess };
